import "./src/styles/global.scss";

export function onRouteUpdate() {
  document.body.focus();
}
